export default __webpack_public_path__ + "static/media/cucumber.c1c9109e.png";